import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import ProductGrid from "@/components/site/ProductGrid";
import Story from "@/components/site/Story";
import Newsletter from "@/components/site/Newsletter";
import Footer from "@/components/site/Footer";
import HolidaySnowfall from "@/components/site/HolidaySnowfall";

export default function LandingPage() {
  return (
    <div data-testid="landing-page">
      <HolidaySnowfall />
      <Navbar />
      <Hero />
      <Marquee />
      <ProductGrid />
      <Story />
      <Newsletter />
      <Footer />
    </div>
  );
}
